// Escopo de visualizacao do CRM: o usuario pode operar focado em 1 clube
// ou em toda a rede (pai + filhos) quando for network admin.
//
// Persistido em localStorage via chave `pps.viewScope.<userId>` pelo
// AuthContext. A UI (sidebar switcher em A.2) le e escreve via
// `useAuth().viewScope` / `setViewScope`.
export type ViewScope =
  | { type: 'club'; clubId: string }
  | { type: 'network'; parentId: string };

export const VIEW_SCOPE_STORAGE_PREFIX = 'pps.viewScope.';

export function viewScopeStorageKey(userId: string): string {
  return `${VIEW_SCOPE_STORAGE_PREFIX}${userId}`;
}

/** Type guard: valida payload lido do localStorage (nao confiavel). */
export function isViewScope(value: unknown): value is ViewScope {
  if (!value || typeof value !== 'object') return false;
  const v = value as Record<string, unknown>;
  if (v.type === 'club') return typeof v.clubId === 'string' && v.clubId.length > 0;
  if (v.type === 'network') return typeof v.parentId === 'string' && v.parentId.length > 0;
  return false;
}
